import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

import {
    CreateAndEditAwardModalProps
} from "./models";

import {CreateAwardRequest, EditAwardRequest} from "models/request";

import { t, Trans } from "@lingui/macro";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import { ContentProducerService } from "services/content-producer-service";
import { ZPlayFormField } from "commons/fields";


const CreateAndEditAwardModalSchema = Yup.object().shape({
    name: Yup.string().required(t({
        id: "caeam-name-required-msg",
        message: "È necessario inserire un nome per poter modificare il premio"
    })),
});

class CreateAndEditAwardModal extends React.Component<CreateAndEditAwardModalProps & UseFormReturn, {}>
{
    componentDidMount() {
        if(this.props.award){
            this.props.setValue("name", this.props.award.value);
        }
    }

    private getValues = () => {
        let value = this.props.getValues("name")
        if(this.props.award){
            this.editAward(value);
        } else {
            this.createAward(value);
        }
    }

    private editAward = (values: any) => {

        let request: EditAwardRequest = {
            value: values
        }

        ContentProducerService.editAward(this.props.award!.id, request, this.props.editAwardCallback, this.props.editAwardErrorCallback)
    }

    private createAward = (values: any) => {

        let request: CreateAwardRequest = {
            value: values
        }

        ContentProducerService.createAward(request, this.props.createAwardCallback, this.props.createAwardErrorCallback);
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {this.props.award? <Trans id="caeam-edit-title">Modifica premio</Trans> : <Trans id="caeam-create-title">Crea premio</Trans>}
                </DialogTitle>
                <form>
                    <DialogContent>
                        <Typography mt={-2}>
                            <Trans id="caeam-award-name-label">Inserisci il nome del premio</Trans>
                        </Typography>
                        <ZPlayFormField
                            label={t({
                                id: "caeam-name",
                                message: "Premio"
                            })}
                            name="name"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"caeam-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            disabled={this.props.formState.isSubmitting}
                            onClick={this.getValues}>
                            {this.props.award? <Trans id="caeam-edit-btn">Modifica</Trans> : <Trans id="caeam-create-btn">Aggiungi</Trans>}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withUseFormHook<{}>(CreateAndEditAwardModal, CreateAndEditAwardModalSchema, {});
